var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.researchQuestionDisplay.showSection)?_c('v-layout',{staticClass:"ml-5",attrs:{"row":""}},[_c('span',{staticClass:"question-text mr-2"},[_vm._v(_vm._s(_vm.$t('ai.questionDisplayPrefix')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.researchQuestion))]),_vm._v(" "),_c('InlineActionBtn',{attrs:{"text":"Edit","icon":"edit"},on:{"onClickAction":_vm.handleEditClick}})],1):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6236bac2","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/searchAi/ResearchQuestionDisplay.vue
// module id = null
// module chunks = 